import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {EventInvitationApiModel} from '../models/event-invitation.api-model';

@Injectable({
  providedIn: 'root'
})
export class EventInvitationRestService {
  private readonly resource: string = '/event_invitations';

  constructor(private http: HttpClient) {}

  public accept(invitation: EventInvitationApiModel): Observable<EventInvitationApiModel> {
    const url = invitation['@id']
      ? `${environment.apiUrl}${invitation['@id']}/accept`
      : `${environment.apiUrl}${this.resource}/${invitation.id}/accept`;
    return this.http.post<EventInvitationApiModel>(url, {})
      .pipe(map((result: EventInvitationApiModel) => plainToClass(EventInvitationApiModel, result)));
  }

  public deny(invitation: EventInvitationApiModel): Observable<EventInvitationApiModel> {
    const url = invitation['@id']
      ? `${environment.apiUrl}${invitation['@id']}/deny`
      : `${environment.apiUrl}${this.resource}/${invitation.id}/deny`;
    return this.http.post<EventInvitationApiModel>(url, {})
      .pipe(map((result: EventInvitationApiModel) => plainToClass(EventInvitationApiModel, result)));
  }
}
